import {
  component$,
  Slot,
  useStyles$,
  useVisibleTask$,
} from "@builder.io/qwik";
import { routeLoader$ } from "@builder.io/qwik-city";
import type { RequestHandler } from "@builder.io/qwik-city";
import AdminToggle from "~/components/system/admin-toggle";
import { datadogRum } from "@datadog/browser-rum";
import config from "~/config";

import Header from "~/components/header";
import Footer from "~/components/footer";

import styles from "./styles.css?inline";
// import bootstrapCss from "./bootstrap.css?inline";
import { getLoggedinApi } from "~/api";

export const onRequest: RequestHandler = async ({
  platform,
  sharedMap,
  cacheControl,
  cookie,
}) => {
  try {
    const token = cookie.get("token")?.value;
    if (!token) return;
    const result = await getLoggedinApi(token, { env: platform.env });
    const user = await result.json();
    if (user) {
      user.isAdmin = (user.roles || []).indexOf("admin") > -1;
      sharedMap.set("user", user);
      sharedMap.set("token", token);
    }
    cacheControl({
      // Max once every 5 seconds, revalidate on the server to get a fresh version of this page
      maxAge: 5,
    });
  } catch (err) {
    console.log(err);
  }
};

// export const onGet: RequestHandler = async ({ cacheControl, platform, cookie }) => {
//   // Control caching for this request for best performance and to reduce hosting costs:
//   // https://qwik.dev/docs/caching/
//   cacheControl({
//     // Always serve a cached response by default, up to a week stale
//     staleWhileRevalidate: 60 * 60 * 24 * 7,
//     // Max once every 5 seconds, revalidate on the server to get a fresh version of this page
//     maxAge: 5,
//   });
// };

export const getUser = routeLoader$(({ sharedMap }) => {
  return { user: sharedMap.get("user"), token: sharedMap.get("token") };
});

export const useServerTimeLoader = routeLoader$(() => {
  return {
    date: new Date().toISOString(),
  };
});

export default component$(() => {
  useStyles$(styles);
  // useStyles$(bootstrapCss);
  const { user } = getUser().value;

  useVisibleTask$(() => {
    datadogRum.init({
      applicationId: config.datadogAppId,
      clientToken: config.datadogClientToken,
      site: "datadoghq.com",
      service: "stockideas-web",

      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sampleRate: 100,
      sessionReplaySampleRate: 20,
      trackInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
    });

    datadogRum.startSessionReplayRecording();

    if (user && user._id) {
      datadogRum.setUser({
        uid: user._id,
        name: user.username,
      });
    }
  });

  return (
    <>
      <Header user={user} />
      {user?.isAdmin ? <AdminToggle /> : null}
      <main style={{ padding: "10px" }}>
        <Slot />
      </main>
      <Footer />
    </>
  );
});
